const getCurrentProductInstance = () => {
  const instances = window.Shopify.theme.sections.instances || [];
  const productInstance = instances.find(instance => instance.id === 'product');
  return productInstance;
}

class PLProductForm {
  constructor(product, form) {
    this.product = product;
    this.form = form;
    this.sellingPlanEl = this.form.querySelector('[data-select-container]') || null;
    this.sellingPlanSelect = this.form.querySelector('[data-selling-plan-select]') || null;
    this.variantIdInput = this.form.querySelector('input[name="id"]');
    this.addToCartButton = this.form.querySelector('button[name="add"]');
    this.availabilityLabel = this.form.querySelector('[data-availability-label]');
    this.prices = [...this.form.querySelectorAll('[data-product-price]')] || null;
    
    
    this.swatches = SwatchControl || null;
    this.stockText = window.theme.strings.products;
    this.variantInventory = JSON.parse(document.getElementById('VariantStock').innerHTML);
    this.state = {
      selectedVariant: null,
      inputs: [],
      selectedOptions: {},
    };
    
    this.productInstance = getCurrentProductInstance();

    this.init();
    
  }
  
  setOptionValueDisplay() {
    const selectedOptions = this.state.selectedOptions;
    const optionNames = Object.keys(selectedOptions);
    const optionValues = Object.values(selectedOptions);
    
    optionNames.forEach((optionName, index) => {
      const optionValue = optionValues[index];
      const optionNameEl = this.form.querySelector(`[data-option-name='${optionName.toLowerCase()}']`);
      if (!optionNameEl) return;
      optionNameEl.textContent = `: ${optionValue}`;
    });
  }
  
  injectSwatchIntoRadio (input, swatch) {
    const defaultSwatch = {
      swatch_color: '#dddddd',
      title: 'Default Gray',
      swatch_image: '',
    };
    
    if (!swatch) {
      swatch = defaultSwatch;
    }
    
    input.parentElement.querySelector('.pl-swatch-button-inner').style.backgroundImage = `url(${swatch.swatch_image})`;
    input.parentElement.querySelector('.pl-swatch-button-inner').style.backgroundColor = swatch.swatch_color;
  };
  
  generateSwatchesForInputs() {
    if (!this.swatches) return;

    this.state.inputs.forEach((input) => {
      const swatchGroup = this.swatches[input.name];
      if (!swatchGroup) return;
      const swatch = swatchGroup.find((swatch) => swatch.title === input.value);
      
      this.injectSwatchIntoRadio(input, swatch);
    });
  }
  
  setOptionsFromSelectedVariant() {
    const variant = this.state.selectedVariant;
    variant.options.forEach((option, index) => {
      
      const optionName = this.product.options[index];
      this.state.selectedOptions[optionName] = option;
    });
    
    this.findVariantFromOptions()
  }
  
  setOptionRadioDOMFromSelectedVariant() {
    const variant = this.state.selectedVariant;
    this.state.inputs.forEach((input) => {
      const optionName = input.name;
      const optionValue = input.value;
      const option = this.state.selectedOptions[optionName];

      if (optionValue === option && input.type === 'radio') {
        input.checked = true;
      }
    });
  }
  
  getVariantIdFromUrlParams() {
    console.log('------ getVariantIdFromUrlParams ------');
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = Number(urlParams.get('variant'));
    if (variantId) {
      this.state.selectedVariant = this.product.variants.find(variant => {
        return variant.id === variantId;
      });
    } else {
      console.log('------ no variant id in url params, setting to first variant ------');
      this.state.selectedVariant = this.product.variants[0];
      // set the url params to the first variant
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('variant', this.state.selectedVariant.id);
      console.log('------ setting url params to first variant ------', urlParams.toString());
      window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
    }
  
    this.setOptionsFromSelectedVariant();
    this.setOptionRadioDOMFromSelectedVariant();
    this.setAddToCartButtonState();
    this.setAvailabilityLabelState();
    this.setOptionValueDisplay();
    
    return variantId;
  }

  updatePrices() {
    if (!this.prices || !this.state.selectedVariant) return;

    this.prices.forEach(priceEl => {
      priceEl.textContent = Shopify.formatMoney(this.state.selectedVariant.price, window.theme.moneyFormat);
    });
  }
  
  updateVariantUrlParams() {
    if (!this.state.selectedVariant) {
      return;
    }
    
    const variantId = this.state.selectedVariant.id;
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('variant', variantId);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
  }

  setAvailabilityLabelState() {
    if (!this.state.selectedVariant) {
      this.availabilityLabel.style.display = 'none';
      return;
    }
    
    this.availabilityLabel.style.display = 'block';
    
    let stockLevel = this.variantInventory[this.state.selectedVariant.id].replace(/-/g, '_');
    if (stockLevel === 'sold_out') {
      stockLevel = 'out_of_stock';
    }

    this.availabilityLabel.textContent = this.stockText[stockLevel];
    if (stockLevel === 'low_stock') {
      this.availabilityLabel.classList.add('orange', 'bold');
    } else {
      this.availabilityLabel.classList.remove('orange', 'bold');
    }
  }

  setAddToCartButtonState() {
    if (this.state.selectedVariant && this.state.selectedVariant.available) {
      this.addToCartButton.textContent = 'Add to Cart';
      this.addToCartButton.classList.remove('disabled', 'hide');
    }
    
    if (this.state.selectedVariant && !this.state.selectedVariant.available) {
      this.addToCartButton.textContent = 'Sold Out';
      this.addToCartButton.classList.add('hide');
    }
  }

  setVariantId() {
    if (this.state.selectedVariant) {
      const variantId = this.state.selectedVariant.id;
      this.variantIdInput.value = variantId;
    } else {
      this.variantIdInput.value = null;
    }
  }

  getFormInputs() {
    const inputs = this.form.querySelectorAll('input[type="radio"]');
    this.state.inputs = Array.from(inputs);
    this.generateSwatchesForInputs();
  }
  
  toggleSubscriptionSelect(shouldDisplay) {
    if (shouldDisplay) {
      this.sellingPlanEl.style.display = 'block';
      this.sellingPlanSelect.setAttribute('name', 'selling_plan');
    } else {
      this.sellingPlanEl.style.display = 'none';
      this.sellingPlanSelect.setAttribute('name', 'selling_plan_type');
    }
  }
  
  findVariantFromOptions() {
    const variants = this.product.variants;

    const selectedOptions = Object.values(this.state.selectedOptions).sort();
    const variant = variants.find(variant => {
      const variantOptions = variant.options.sort();
      return variantOptions.join('_') === selectedOptions.join('_');
    });

    this.state.selectedVariant = variant;
    
    return variant;
  }
  
  updateSelectedImagesForVariant() {
    if (!this.productInstance || !this.state.selectedVariant || this.state.selectedVariant.featured_media === null) {
      return;
    }

    this.productInstance.renderFeaturedImage(this.state.selectedVariant.featured_media.id);
    this.productInstance.renderActiveThumbnail(this.state.selectedVariant.featured_media.id);
  }

  addEventListeners() {
    const activeClass = 'is-active';

    this.form.addEventListener('change', (e) => {
      const option = e.target;

      if (!option.hasAttribute('data-type-option')) return;
      this.state.selectedOptions[option.name] = option.value;

      if (option.checked) {
        option.parentElement.classList.add(activeClass);
      } else {
        option.parentElement.classList.remove(activeClass);
      }
      
      
      if (option.name !== 'selling_plan_type') {
        this.findVariantFromOptions()
      }
      
      this.setVariantId();
      this.setAddToCartButtonState();
      this.setAvailabilityLabelState();
      this.updateVariantUrlParams();
      this.updatePrices()
      this.updateSelectedImagesForVariant();
      this.setOptionValueDisplay();
      
      if (this.sellingPlanEl) {
        this.toggleSubscriptionSelect(option.value === 'recurring' && option.name === 'selling_plan_type');
      }
    });
  }

  setProductOptionState() {
    this.product.options.forEach(option => {
      this.state.selectedOptions[option] = ''
    });
  }

  init() {
    this.setProductOptionState();
    this.getFormInputs();
    console.log('------ init right before getVariantIdFromUrlParams ------');
    this.getVariantIdFromUrlParams();
    console.log('------ init right after getVariantIdFromUrlParams ------');
    this.addEventListeners();
  }
}

class PLProductGallery {
  constructor(product) {
    this.product = product;
    
    this.selectors = {
      thumbnails: [...document.querySelectorAll('[data-product-single-thumbnail]')],
    }
    
    this.productInstance = getCurrentProductInstance();
    
    this.init();
  }
  
  waitForGalleryElements() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if this is the product section or contains gallery elements
              if (node.hasAttribute && (
                node.hasAttribute('data-section-type') && 
                node.getAttribute('data-section-type') === 'product' ||
                node.querySelector && node.querySelector('[data-carousel]')
              )) {
                this.onGalleryReady();
                observer.disconnect();
                return;
              }
            }
          });
        }
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check if elements already exist
    if (this.checkGalleryReady()) {
      this.onGalleryReady();
      observer.disconnect();
    }
  }
  
  onGalleryReady() {
    if (this.productInstance) {
      this.productInstance.initProductCarousel();
      this.addEventListeners();
    }
  }
    
  checkGalleryReady() {
    const carousel = document.querySelector('[data-carousel]');
    const thumbnails = document.querySelectorAll('[data-product-single-thumbnail]');
    return carousel && thumbnails.length > 0;
  }
  
  init() {    
    this.waitForGalleryElements();
  }

  addEventListeners() {
    this.selectors.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => e.preventDefault());
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var productTemplate = document.querySelector('.template-product');
  var productJson = document.querySelector('[data-product-json]');
  var productFormElement = document.querySelector('form[name="pl-product-form"]');
  if (!productTemplate || !productJson || !productFormElement) {
    throw new Error('Product template, product JSON, or product form element not found');
  }
  
  var productData = JSON.parse(productJson.textContent);
  new PLProductForm(productData, productFormElement);
  new PLProductGallery(productData);
});